import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faFlag, faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useParams } from 'react-router-dom'
import { useGetActionsQuery } from '../actions/actionsApiSlice'
import { memo } from 'react'
import useAuth from "../../hooks/useAuth"
import getFilePath from "../../utils/getFilePath"

const Grade = ({ response, actions , inx }) => {
    const { isTeacher, isAdmin } = useAuth()
    const {groupId, taskId, type} = useParams()
    const navigate = useNavigate() 

    if (response) {
        const responseId = response._id;
        const action = actions.entities[response.action]
        const grade = response.grade || -1;

        const handleShow = () =>  navigate(`/${type}/${groupId}/grades/task/${taskId}/${responseId}`)

        return (
            <tr className="table__row">
                <td className="table__cell response__text"> {inx}. {response.updated &&<FontAwesomeIcon icon={faFlag} />} {response.username}</td>
                <td className="table__cell response__text">
                <span className="d-flex">
                    {response.fullname}
                    {response.userImage && <div className='profile-image' style={{backgroundImage:`url(${getFilePath(response.userImage)})`}}></div>}
                    </span>
                    </td>
                    <td className="table__cell response__text">
                        {response.group_model?.name}- {response.group_model?.year}
                    </td>
                <td className="table__cell response__text">{action.text}</td>
                <td className="table__cell response__text">{response.comments}</td>
                {/* <td className="table__cell response__text">{response.responseAt}</td> */}

                <td className="table__cell action__status">
                    {grade > -1
                    ? <span className="status--completed">{grade}</span>
                    : <span className="status--open">לא ניתן ציון</span>
                    } 
                </td>
                {/* <td className="table__cell response__text">{response.gradeBy}</td> */}

                <td className="table__cell">
                   <button
                        className="icon-button table__button"
                        onClick={handleShow}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
               
                  
                </td>
            </tr>
        )

    } else return null
}

const memoizedGrade = memo(Grade)

export default memoizedGrade